/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateRefundRequest } from '../models/CreateRefundRequest';
import type { RefundOverviewData } from '../models/RefundOverviewData';
import type { RefundOwnerType } from '../models/RefundOwnerType';
import type { RefundResultData } from '../models/RefundResultData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RefundsService {
  /**
   * Get Refund Overview
   * @param ownerType
   * @param ownerId
   * @returns RefundOverviewData Successful Response
   * @throws ApiError
   */
  public static getRefundOverview(ownerType: RefundOwnerType, ownerId: string): CancelablePromise<RefundOverviewData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/refunds/overview',
      query: {
        owner_type: ownerType,
        owner_id: ownerId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Refund
   * @param requestBody
   * @returns RefundResultData Successful Response
   * @throws ApiError
   */
  public static createRefund(requestBody: CreateRefundRequest): CancelablePromise<RefundResultData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/refunds',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
